var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.383 25.385-5.977-5.978a10.461 10.461 0 0 0 1.604-5.578c0-5.803-4.703-10.506-10.507-10.506C7.7 3.323 3 8.028 3 13.829c0 5.803 4.703 10.506 10.506 10.506a10.478 10.478 0 0 0 6.002-1.883l5.905 5.908a2.102 2.102 0 0 0 2.973 0c.82-.822.82-2.153-.003-2.975zM13.506 20.93a7.103 7.103 0 1 1 .001-14.206 7.103 7.103 0 0 1 0 14.206z",
    fill: "#FFE14B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fbbdf496e2bb399d17f74e5bcd63373a.svg";
export { ForwardRef as ReactComponent };